import React from 'react';
import Icon from './Icon';

export default class IconCheck extends Icon {

    renderIcon() {
        const color = this.props.color ? this.props.color : (this.state.hover ? '#ec6b05' : '#A6ACAF')
        return (
            <svg width={this.getSize()} height={this.getSize()} viewBox="0 0 14 14">
                <path fill={color} fillRule="nonzero"
                      d="M11.854 4.474l-.3-.319a.48.48 0 0 0-.706 0L5.779 9.087 3.152 6.288a.481.481 0 0 0-.707 0l-.3.319A.547.547 0 0 0 2 6.983c0 .143.052.277.146.377l2.966 3.16a.119.119 0 0 0 .013.017l.3.313c.094.1.22.15.354.15.135 0 .26-.05.355-.15l.3-.316.01-.014 5.41-5.294a.556.556 0 0 0 0-.752z"/>
            </svg>
        )
    }
}